/* esm.sh - applesauce-content@6.0.0/dist/nast/eol-metadata */
export * from "/*applesauce-content@6.0.0/esnext/dist/nast/eol-metadata.mjs";
